import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { FlexAlignCenter } from 'components/primitives/flex';
import { mediaMSmMax } from 'helpers/breakpoints';
import { useAtomValue } from 'jotai';
import { useBreakpoint } from 'components/BreakpointProvider';
import { getFilterButtons } from './filterButtons';
import FilterButton from './FilterButton';
import { isPriceFilterActiveAtom } from './filterStore';

export default function Filter(props) {
  const [dropActiveName, setDropActiveName] = useState<string>(null);
  const filterButtons = useMemo(() => getFilterButtons(), []);
  const scrollContainerRef = useRef(null);
  const buttonRefs = useRef({});
  const dummyRef = useRef(null);
  const filterActive = useAtomValue(isPriceFilterActiveAtom);
  const breakpoints = useBreakpoint();

  useEffect(() => {
    if (filterActive && dropActiveName === 'price' && breakpoints.sm) {
      const activeButton = buttonRefs.current[dropActiveName]?.current;
      if (activeButton) {
        setTimeout(() => {
          dummyRef.current.scrollIntoView({
            behavior: 'smooth',
          });
        }, 1);
      }
    }
  }, [filterActive, dropActiveName]);

  const toggleFilterDropdown = (filterName: string) => {
    if (dropActiveName === filterName) {
      setDropActiveName(null);
    } else {
      setDropActiveName(filterName);
      if (buttonRefs.current[filterName]?.current && breakpoints.sm) {
        const button = buttonRefs.current[filterName].current;
        button.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
  };

  useEffect(() => {
    filterButtons.forEach(({ name }) => {
      buttonRefs.current[name] = React.createRef();
    });
  }, [filterButtons]);

  return (
    <FilterButtons gap="14px" flex="1" {...props} ref={scrollContainerRef}>
      {breakpoints.sm ? <div style={{ width: '15px' }} /> : null}
      {filterButtons.map(({ label, content, name, isFilterActiveAtom, isFilterHiddenAtom, CustomButton }) => (
        <div key={name} ref={buttonRefs.current[name]}>
          {CustomButton ? (
            <CustomButton
              name={name}
              toggleFilterDropdown={toggleFilterDropdown}
              dropdownActive={name === dropActiveName}
              isFilterHiddenAtom={isFilterHiddenAtom}
            />
          ) : (
            <FilterButton
              name={name}
              label={label}
              toggleFilterDropdown={toggleFilterDropdown}
              dropdownActive={name === dropActiveName}
              content={content}
              isFilterActiveAtom={isFilterActiveAtom}
              isFilterHiddenAtom={isFilterHiddenAtom}
              hideCloseButton
            />
          )}
        </div>
      ))}
      <div style={{ width: '150px' }} ref={dummyRef} />
    </FilterButtons>
  );
}

const FilterButtons = styled(FlexAlignCenter)`
  ${mediaMSmMax} {
    overflow-x: scroll;
    scrollbar-width: none;
    gap: 8px;
    padding: 8px 5px;
  }
`;
